import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ProductService} from '../../../shared/services/product.service';
import {Router} from '@angular/router';
import {AppConstants} from '../../../shared/constants/app-constant';

@Component({
    selector: 'app-my-products',
    templateUrl: './my-products.component.html',
    styleUrls: ['./my-products.component.scss']
})
export class MyProductsComponent implements OnInit {
    showSearch = false;
    searchForm: FormGroup;
    myProducts: any = [];
    submitting: any = false;
    imageBaseUrl: any = AppConstants.BUCKET_URL;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private fb: FormBuilder,
                private productService: ProductService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
            'quantity': [''],
            'mrp': [''],
            'batch': ['']
        });
        this.get();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.myProducts = [];
        this.productService.getMyProducts(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.myProducts = data['data'];
            } else {
                this.myProducts = [];
            }
            this.pagination = {
                page: data.current_page,
                total: data.total,
                perpage: data.per_page,
                pages: data.last_page,
            };
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'quantity': (this.searchForm.value && (this.searchForm.value.quantity || this.searchForm.value.quantity == 0)) ? this.searchForm.value.quantity : '',
            'mrp': (this.searchForm.value && (this.searchForm.value.mrp || this.searchForm.value.mrp == 0)) ? this.searchForm.value.mrp : '',
            'batch': (this.searchForm.value && this.searchForm.value.batch) ? this.searchForm.value.batch : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'quantity': (this.searchForm.value && this.searchForm.value.quantity) ? this.searchForm.value.quantity : '',
            'mrp': (this.searchForm.value && this.searchForm.value.mrp) ? this.searchForm.value.mrp : '',
            'batch': (this.searchForm.value && this.searchForm.value.batch) ? this.searchForm.value.batch : ''
        };
        this.get(params);
    }

    goTo() {
        this.router.navigateByUrl('products');
    }
}
